
<template>
  <el-main>
    <el-card shadow="never">
      <div class="input_box">
        <div class="input-box">
          <el-input
            size="mini"
            placeholder="请输入员工名称"
            v-model="searchName">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
        <el-button style="margin-left: 10px" @click="doSearch" size="mini" type="primary">{{language("awaitDaily_dailyList.搜索")}}</el-button>
        <span style="margin-left: 10px;color: red">(注意：恢复账号后初始密码为：123456)</span>
      </div>
    </el-card>
    <cc-table
      :loadData="true"
      :config="configTable"
      :params="paramsTable"
      :refeshParams="refreshTable"
      :autoButtonWidth="true"
      :buttonsWidth="60"
      @submit-select="result"
      :submitSelectedButton="false"
      ref="table"
    >
    </cc-table>
  </el-main>
</template>
<script>
export default {
  data() {
    return {
      searchName: '',
      showSearch: false,
      searchConfig: [],
      refreshTable: -1,
      paramsTable: {
        name: ''
      },
      paramsTable2: {},
      configTable: {
        api: "admin/fsb/cms/user/removed",
        pageSize: 10,
        showPager: true,
        selection: true,
        selectionNoSubmit: true, //不显示确定选择按钮
        selectingResult: true,
        selectionLabel: "恢复选中的账号",
        columns: [
          { prop: "account", lable: "账号", minWidth: "150" },
          { prop: "name", lable: "姓名", minWidth: 100 },
          { prop: "roleName", lable: "角色", minWidth: 100 },
          { prop: "deptName", lable: "部门", minWidth: 100 },
          { prop: "sapNumbering", lable: "员工编号", minWidth: 100 },
          {
            type: "tag",
            prop: "status",
            lable: "状态",
            minWidth: 100,
            options: {
              1: { text: "启用", tagType: "success" },
              2: { text: "冻结", tagType: "danger" },
              3: { text: "已删除", tagType: "danger" },
            },
          },
        ],
        buttons: [],
      },
      ids: [],
    };
  },
  methods: {
    //搜索
    doSearch() {
      this.paramsTable.name = this.searchName;
    },
    result(e) {
      let ids = [];
      for (let index = 0; index < e.length; index++) {
        ids.push(e[index]);
      }
      this.ccRequest.do(`admin/fsb/cms/user/restore`,{
        ids: ids
      },"POST").then(() => {
        this.refreshTable = new Date().getTime();
        this.$message({message: "恢复成功", type: "success"});
      }).catch((err) => {
        this.$message.error(err.response.data.message);
      });
    },
  },
  mounted() {

  },
};
</script>
<style scoped>
.input_box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.input {
  margin: 10px 20px 10px 0;
}
</style>
